import * as React from 'react';

const BackwardIcon = ({fillColor = '#2D2756'}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14}>
    <path
      fill={fillColor}
      d="M6.313 13.23.52 7.437a.635.635 0 0 1-.146-.209A.612.612 0 0 1 .333 7c0-.083.014-.16.042-.23a.635.635 0 0 1 .146-.207L6.333.75A.565.565 0 0 1 6.75.583a.6.6 0 0 1 .438.188.6.6 0 0 1 .187.437.6.6 0 0 1-.187.438l-4.73 4.729h10.334a.607.607 0 0 1 .625.625.607.607 0 0 1-.625.625H2.458l4.75 4.75c.111.111.167.25.167.417a.6.6 0 0 1-.187.437.6.6 0 0 1-.438.188.6.6 0 0 1-.437-.188Z"
    />
  </svg>
);

export default BackwardIcon;
